import React from 'react';
import { Grid, Card, CardContent, Typography, Box, Chip } from '@mui/material';

const AdminStatsCards = ({ stats, onTabChange }) => (
  <Grid container spacing={3} mb={4}>
    <Grid item xs={12} md={3}>
      <Card sx={{ backgroundColor: '#e3f2fd' }}>
        <CardContent>
          <Typography variant="h4" fontWeight="bold" color="primary">
            {stats.totalProjects}
          </Typography>
          <Typography variant="body2" color="text.secondary">Total Projects</Typography>
        </CardContent>
      </Card>
    </Grid>
    <Grid item xs={12} md={3}>
      <Card sx={{ backgroundColor: '#f3e5f5' }}>
        <CardContent>
          <Typography variant="h4" fontWeight="bold" color="secondary">
            {stats.totalItems}
          </Typography>
          <Typography variant="body2" color="text.secondary">Total Items</Typography>
        </CardContent>
      </Card>
    </Grid>
    <Grid item xs={12} md={6}>
      <Card sx={{ backgroundColor: '#fafafa' }}>
        <CardContent>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Filter Items by Status:
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            <Chip
              label={`${stats.approvedItems} Approved`}
              color="success"
              clickable
              onClick={() => onTabChange(0)}
              icon={<Box component="span" sx={{ fontSize: '1.2em' }}>✓</Box>}
            />
            <Chip
              label={`${stats.pendingApprovals} Outstanding`}
              color="warning"
              clickable
              onClick={() => onTabChange(0)}
              icon={<Box component="span" sx={{ fontSize: '1.2em' }}>⏱</Box>}
            />
            <Chip
              label={`${stats.rejectedItems} Rejected`}
              color="error"
              clickable
              onClick={() => onTabChange(0)}
              icon={<Box component="span" sx={{ fontSize: '1.2em' }}>✕</Box>}
            />
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            Click on a project tile below to view and filter items
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
);

export default AdminStatsCards;
